<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">400</h1>
            <h4 class="pt-3">{{ $t("errors.notfounddata") }}</h4>
            <p class="d-flex detail-text">
              {{ $route.query.errorKey ? $t('errors.' + $route.query.errorKey) : $t('errors.problemaccess') }}
            </p>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<style lang="scss">
.detail-text {
  font-size: 1.1rem;
}
</style>

<script>
import jwtMixin from '../../mixins/jwtMixin'

export default { name: 'Page400',
  mixins: [jwtMixin],
  created () {
    this.$i18n.locale = this.jwtLanguage()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/pages/Page400.vue